import { memo, useContext } from 'react'

import { Badge, CircularProgress } from '@mui/material'

import { TabPanel, TabPanelLocation } from '@tabeeb/enums'
import { useSelector } from '@tabeeb/store'
import { ToggleButtonProps } from '@collaborate-health/uikit'

import { getContentId } from '@tabeeb/shared/content/selectors'
import { UnreadTrainingMaterialsContext } from '@tabeeb/modules/articles/contexts'
import { getIsTabOpen } from '@tabeeb/modules/sessionTabs/selectors'
import { isTabVisibleSelectors, TabBubbleSelectors, TabIcons, isTabInProgressSelectors } from '../../constants'

import { NavbarToggleButton } from './TabButton.styles'

export interface TabButtonProps extends ToggleButtonProps {
  value: TabPanel
  location: TabPanelLocation
}

const TabButton: React.FC<TabButtonProps> = ({ value, location, ...rest }) => {
  // TODO: Remove this after session tabs refactor
  // eslint-disable-next-line no-unused-vars
  useContext(UnreadTrainingMaterialsContext)

  const contentId = useSelector(getContentId)
  const bubbleValueSelector = TabBubbleSelectors[value] || (() => 0)
  const bubbleValue = useSelector((state) => bubbleValueSelector(state, { contentId }))

  const icon = TabIcons[value]

  const isInProgressSelector = isTabInProgressSelectors[value] || (() => false)
  const isInProgress = useSelector(isInProgressSelector)
  const isSelected = useSelector((state) => getIsTabOpen(state, value))

  const isPanelVisible = useSelector(isTabVisibleSelectors[value])
  if (!isPanelVisible) {
    return null
  }

  return (
    <NavbarToggleButton data-location={location} value={value} selected={isSelected} {...rest}>
      <Badge badgeContent={bubbleValue} color='accent' max={Number.MAX_SAFE_INTEGER}>
        {isInProgress ? <CircularProgress size={20} /> : icon}
      </Badge>
    </NavbarToggleButton>
  )
}

export default memo(TabButton)

